var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "03_\u6253\u5370") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.73,56H42.19a3.36,3.36,0,0,0,3.36-3.36V43.26a1,1,0,0,0-1-1H19.24a1,1,0,0,0-1,1v9.25A3.5,3.5,0,0,0,21.73,56ZM42.18,8H21.62a3.38,3.38,0,0,0-3.38,3.38v8.19a2,2,0,0,0,2,2H43.55a2,2,0,0,0,2-2v-8.2A3.37,3.37,0,0,0,42.18,8Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M49,23.57v.5a1,1,0,0,1-1,1H15.79a1,1,0,0,1-1-1v-.5a2,2,0,0,0-2-2H10a2,2,0,0,0-2,2v27a2,2,0,0,0,2,2h3.84a1,1,0,0,0,1-1V39.81a1,1,0,0,1,1-1H48a1,1,0,0,1,1,1V51.55a1,1,0,0,0,1,1h4a2,2,0,0,0,2-2v-27a2,2,0,0,0-2-2H51A2,2,0,0,0,49,23.57ZM48,32H39.77a1,1,0,0,1-1-1v-1.5a1,1,0,0,1,1-1H48a1,1,0,0,1,1,1V31A1,1,0,0,1,48,32Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.df20e9ab.svg";
export { ForwardRef as ReactComponent };